export default "__VITE_ASSET__77ffcb9f__"